export const MAIN_COLOR = 'rgb(10, 150, 255)';
export const COLOR_BORDER_ELEMENTS = 'rgb(221, 221, 227)';
export const COLOR_NAVIGATE_BOTTOM = 'rgb(10, 104, 255)';
export const COLOR_CARD_ELEMENTS = 'rgba(0, 96, 255, 0.12)';
export const COLOR_INDACATOR = 'rgb(10, 150, 255)';
export const BOX_SHADOW = 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;';
export const MALE_ID = '66eac5c7f7adcbed07e215bd';
export const FEMALE_ID = '66eac608a9606d68cd102d21';

export const typeRole = {
    GUEST: 'GUEST',
    CTV: 'CTV',
    ADMIN: 'ADMIN',
    SUB_ADMIN: 'SUB_ADMIN',
    ADMIN_CTV: 'ADMIN_CTV',
    SHOP: 'SHOP',
};
export const typeLng = {
    VN: 'vn',
    EN: 'en',
};

export const typeRank = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    DIAMONDS: 'DIAMONDS',
};
export const HOST_BE = 'https://dhsneaker-api.io.vn';
export const SOCKET_HOST = 'https://dhsneaker-api.io.vn';
export const HOST_FE = 'https://dhsneaker.com';
export const REDIRECT_URL_GMAIL = 'https://dhsneaker.com/login-register';

// export const HOST_BE = 'http://localhost:3035';
// export const HOST_FE = 'http://localhost:3000';
// export const SOCKET_HOST = 'http://localhost:3051';
// export const REDIRECT_URL_GMAIL = 'http://localhost:3000/login-register';
export const USD = 25800;
